import * as APIRoutes from '@mm/api-routes';
import RssFeedModel from '../model/RssFeedModel';
import AuthenticatedController from './AuthenticatedController';

export default class RssFeedController extends AuthenticatedController {
  static async getAll(botId: number) {
    const response = await super.get(APIRoutes.RSS_FEEDS(botId));
    return response as RssFeedModel[];
  }

  static async getById(botId: number, feedId: number) {
    const response = await super.get(`${APIRoutes.RSS_FEEDS(botId)}/${feedId}`);
    return response as RssFeedModel;
  }

  static async postRssFeed(botId: number, entity: Partial<RssFeedModel>) {
    const response = await super.post(APIRoutes.RSS_FEEDS(botId), entity);
    return response as RssFeedModel;
  }

  static async putRssFeed(botId: number, entity: Partial<RssFeedModel>) {
    const response = await super.put(
      `${APIRoutes.RSS_FEEDS(botId)}/${entity.id}`,
      entity,
    );
    return response as RssFeedModel;
  }

  static async deleteRssFeed(botId: number, entityId: number) {
    return super.delete(`${APIRoutes.RSS_FEEDS(botId)}/${entityId}`);
  }
}
